module.exports = __webpack_public_path__ + "static/media/2.68386ea7.jpeg";